import { render, staticRenderFns } from "./ProductTiers.vue?vue&type=template&id=0d1c98de&"
import script from "./ProductTiers.vue?vue&type=script&lang=ts&"
export * from "./ProductTiers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports